import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gn_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login") && !e.config.url.includes("/public/")) {
      localStorage.removeItem("gn_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const waPhone = (p) => { const d = (p || "").replace(/\D/g, ""); return d.length === 10 ? `91${d}` : d; };
export const inr = (n) => `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;
export const fdate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fdt = (s) =>
  s ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const imgUrl = (p) => (p?.startsWith("http") ? p : `${API}/files/${p}`);
const ACRONYMS = { Cpu: "CPU", Ram: "RAM", Ssd1: "SSD 1", Ssd2: "SSD 2", Hdd: "HDD", Psu: "PSU" };
export const label = (s) => (s || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
  .replace(/\b(Cpu|Ram|Ssd1|Ssd2|Hdd|Psu)\b/g, (w) => ACRONYMS[w]);

export const CATEGORIES = ["CPU", "MOTHERBOARD", "COOLER", "RAM", "GRAPHICS_CARD", "SSD1", "SSD2", "HDD", "CHASSIS", "PSU",
  "HEADPHONES", "MOUSE", "KEYBOARD", "MONITOR", "FANS", "CUSTOM_ACCESSORY"];

export function useApi(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!path) return;
    try {
      const r = await api.get(path);
      setData(r.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => { reload(); }, [reload]);
  return { data, setData, loading, reload };
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/upload", fd);
  return r.data.path;
}
